const toWeeks = (days) => Math.max(1, Math.round(days / 7));

export const explainSignal = (source, data = {}) => {
  switch (source) {
    case 'knowledge': {
      if (data.enrichment || data.rule === 'enrichment') {
        return `Ai atins tinta (${data.totalCredits}/${data.targetSum}). Activitati optionale pentru imbogatire`;
      }
      const suffix = data.rolloverCredits > 0
        ? ` (ai deja ${Math.round(data.rolloverCredits)} din anul trecut)`
        : '';
      return `Iti lipsesc ${data.deficit} credite in ${data.moduleCode}${suffix}`;
    }
    case 'user-cf':
      return `${data.neighborCount} elevi cu profil similar au facut asta`;
    case 'item-cf':
      return `Elevii care au facut activitati similare au ales si asta (${data.neighborCount} colegi)`;
    case 'content':
      return data.anchorName
        ? `Similar cu activitatea ta "${data.anchorName}"`
        : 'Similar cu activitatile tale preferate';
    case 'temporal':
      return data.moduleCode
        ? `Disponibil acum, in ${data.moduleCode}`
        : 'Disponibil in perioada curenta';
    case 'predictive':
      return data.daysSaved
        ? `Te ajuta sa atingi tinta cu ${toWeeks(data.daysSaved)} saptamani mai repede`
        : 'Te ajuta sa atingi tinta anuala';
    default:
      return '';
  }
};

export const buildExplanations = (recommendation, limit = 2) =>
  Object.entries(recommendation.contributions || recommendation.breakdown || {})
    .filter(([, score]) => score > 0)
    .sort((a, b) => b[1] - a[1])
    .slice(0, limit)
    .map(([source]) => explainSignal(source, recommendation.signals?.[source] || {}))
    .filter(Boolean);
